<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<!-- <Button
            :label="$t('create')"
            color="trv-default"
            semanticClass="tiny"
            @click="showNewModelForm"
            widthAuto
          /> -->
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.prla_cd_codigo }} - {{ $t('plantio') }} :
								{{ item.plantio }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVParcela()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="quantityPerPage"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 0.5rem; flex-direction: column">
					<DropdownFk
						v-model="model.fk_ptio_plantio"
						:label="$t('plantation') + '*'"
						:dropdown-options="plantios"
					/>
					<InputText
						v-model="model.prla_cd_codigo"
						:label="$t('code') + '*'"
					/>
					<InputText
						v-model="model.prla_md_area"
						:label="$t('area') + '*'"
						:mask="[
							'#',
							'#.#',
							'#.##',
							'##.##',
							'###.##',
							'####.##',
							'#####.##',
							'######.##',
							'#######.##',
							'########.##',
						]"
					/>
					<Dropdown
						v-model="model.prla_tx_formato"
						:label="$t('format') + '*'"
						:options="[
							{ value: 'Circular', label: $t('circular') },
							{ value: 'Quadrada', label: $t('square') },							
							{ value: 'Retangular', label: $t('rectangular') },
							
						]"
					/>

					<!-- <Accordion
            :label="$t('optionalFields')"
            :hints="[$t('description'), $t('slope'), $t('xCoordinate')]"
          > -->
					<div style="display: flex; gap: 0.5rem; flex-direction: column">
						<InputText
							v-model="model.prla_ds_descricao"
							:label="$t('description')"
						/>
						<InputText
							v-model="model.prla_md_inclinacao"
							:label="$t('slope')"
							:mask="[
								'#',
								'#.#',
								'#.##',
								'##.##',
								'###.##',
								'####.##',
								'#####.##',
								'######.##',
								'#######.##',
								'########.##',
							]"
						/>
						<InputText
							v-model="model.prla_md_coord_x"
							:label="$t('xCoordinate')"
						/>
						<InputText
							v-model="model.prla_md_coord_y"
							:label="$t('yCoordinate')"
						/>
					</div>
					<!-- </Accordion> -->
					<Accordion
						v-show="isSupportMode"
						:label="$t('attentionZone')"
						:hints="[$t('changeTheOS')]"
						warning
					>
						<div style="display: flex; gap: 0.5rem; flex-direction: column">
							<!-- <span>{{$t('changeOSDescription')}}</span> -->
							<span
								v-if="!model.ospls.length"
								style="color: var(--color-error-indicator); text-align: center; padding: 1rem"
							>
								{{ $t('parcelaSemVinculoComOS') }}
							</span>
							<div v-else>
								<h5>
									{{ $t('parcelaVinculadaOS') }}
								</h5>
								<ul>
									<li
										v-for="ospl in model.ospls"
										:key="ospl.id"
									>
										{{
											ordensServico.find((os) => os.id === ospl.fk_orsv_ordem_servico)[
												$t('description')
											]
										}}
									</li>
								</ul>
							</div>

							<h3 style="margin: 0">Criar vínculo de Ordem de Serviço</h3>
							<h5 style="margin: 0">
								{{ $t('escolhaOSParaCriarVinculo') }}
							</h5>
							<div style="display: flex; gap: 1rem; flex-direction: column">
								<DropdownFk
									v-model="osVinculoId"
									:label="$t('serviceOrder')"
									:dropdown-options="ordensServico"
								/>
								<Button
									:disabled="!osVinculoId"
									:loading="changing"
									:label="`${$t('bondwithOs')} ${
										osVinculoId
											? ordensServico.find((os) => os.id === osVinculoId)[$t('description')]
											: ''
									}`"
									@click="createOspl"
								/>
							</div>
						</div>
					</Accordion>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Accordion from '../../../../components/Accordion/Accordion'
import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../../components/DownloadButton/DownloadButton";
import Dropdown from '../../../../components/Dropdown/Dropdown'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import GridPagination from '../../../../components/GridPagination/GridPagination.vue'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createOrdemServicoParcela,
	createParcela,
	deleteParcelaByIdList,
	updateParcela,
	getAllParcelasPagination,
} from '../../../../services/requests/ParcelaRequests'

import { getAllOrdensDeServicos } from '../../../../services/requests/OrdemDeServicoRequests'
import { getDropdownPlantios } from '../../../../services/requests/PlantioRequests'

import validarParcela from '../../../../validations/ParcelaValidation'
import download from 'downloadjs'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Accordion,
		Button,
		CrudForm,
		CrudTable,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		GridPagination,
		DropdownFk,
		KebabMenu,
		Dropdown,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			osVinculoId: undefined,
			totalRecords: 0,
			textFilter: '',
			changing: false,
			fk_os: undefined,
			ordensServico: [],
			showExclusionAlert: false,
			intention: {},
			headersSelecionados: [
				'prla_md_area',
				'prla_tx_formato',
				'prla_ds_descricao',
				'plantio',
				'prla_cd_codigo',
			],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				prla_cd_codigo: '',
				prla_ds_descricao: '',
				prla_tx_formato: '',
				prla_md_inclinacao: '',
				prla_md_area: '',
				prla_md_coord_x: '',
				prla_md_coord_y: '',
				fk_ptio_plantio: '',
				ospls: [],
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'prla_cd_codigo',
				titleCardPropertie: 'prla_ds_descricao',
			},

			tableHeaders: [
				{ key: 'prla_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'plantio', value: this.$t('plantation'), isActive: true },
				{
					key: 'prla_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{ key: 'prla_tx_formato', value: this.$t('format'), isActive: true },
				{
					key: 'prla_md_inclinacao',
					value: this.$t('slope'),
					isActive: false,
				},
				{ key: 'prla_md_area', value: this.$t('area'), isActive: true },
				{
					key: 'prla_md_coord_x',
					value: this.$t('xCoordinate'),
					isActive: false,
				},
				{
					key: 'prla_md_coord_y',
					value: this.$t('yCoordinate'),
					isActive: false,
				},
			],
			/**
			 * plantios que serão dispostas no dropdown para atrelar a parcela
			 */
			plantios: [],
		}
	},
	computed: {
		isSupportMode() {
			return localStorage.getItem('supportMode')
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return (
				this.model.fk_ptio_plantio &&
				this.model.prla_cd_codigo &&
				this.model.prla_md_area &&
				this.model.prla_tx_formato
			)
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
		textFilter(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},
	},
	destroyed() {
		localStorage.removeItem('supportMode')
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['prla_cd_codigo']
		getAllParcelasPagination().then((response) => {
			const parcelas = response.data.result
			this.totalRecords = response.data.result[0].totalRegistros
			parcelas.forEach((parcela) => this.formataModelParaCrud(parcela))
			this.modelList = parcelas
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getDropdownPlantios().then((response) => {
			this.plantios = response
		})

		getAllOrdensDeServicos().then((response) => {
			this.ordensServico = response.data.result.map(
				({ id, esfl_ds_descricao, orsv_ds_descricao }) => {
					return {
						id,
						[this.$t('description')]: orsv_ds_descricao,
						[this.$t('forestStratification')]: esfl_ds_descricao,
					}
				},
			)
		})
	},
	methods: {
		createOspl() {
			this.changing = true
			const newOspl = {
				fk_orsv_ordem_servico: this.osVinculoId,
				id: uuidv4(),
				fk_prla_parcela: this.model.id,
			}

			createOrdemServicoParcela(newOspl)
				.then((response) => {
					this.changing = false
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageText: response.data.message,
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					this.model.ospls.push(newOspl)
				})
				.catch(() => {
					this.changing = false

					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('contateOSuporte'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},

		refreshTabela(pageNumber, pageSize, filteringWord) {
			getAllParcelasPagination(pageNumber, pageSize, filteringWord).then((response) => {
				const parcelas = response.data.result
				if (!parcelas || parcelas.length === 0) {
					return
				}
				this.totalRecords = response.data.result[0].totalRegistros
				parcelas.forEach((parcela) => this.formataModelParaCrud(parcela))
				this.modelList = parcelas
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createModelToPost() {
			return {
				id: uuidv4(),
				prla_cd_codigo: this.model.prla_cd_codigo.trim(),
				prla_ds_descricao: this.model.prla_ds_descricao,
				prla_tx_formato: this.model.prla_tx_formato,
				prla_md_inclinacao: this.model.prla_md_inclinacao,
				prla_md_area: this.model.prla_md_area,
				prla_md_coord_x: this.model.prla_md_coord_x,
				prla_md_coord_y: this.model.prla_md_coord_y,
				fk_ptio_plantio: this.model.fk_ptio_plantio,
			}
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataModelParaCrud(model) {
			model.isCheckedToDelete = false
			model.ordens = model.ospls?.map((ospl) => ospl.fk_orsv_ordem_servico).toString()
			model.prla_md_inclinacao = model.prla_md_inclinacao?.toFixed(2)
			model.prla_md_area = model.prla_md_area?.toFixed(2)
		},

		/**
		 * Seta fk de solo no model vinda do dropdown
		 */
		setSolo(value) {
			this.model.fk_tpsl_tipo_solo = value
		},

		/**
		 * Seta fk de fazenda no model vinda do dropdown
		 */
		setFazenda(value) {
			this.model.fk_fzda_fazenda = value
		},

		/**
		 * Cria nova Fazenda no banco de dados
		 */
		create() {
			const parcela = this.createModelToPost()
			const { isValid } = validarParcela(parcela, this.modelList)

			if (isValid) {
				createParcela(parcela).then((response) => {
					const { result: model, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						this.formataModelParaCrud(model)
						this.modelList.unshift(model)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Atualiza fazenda no banco de dados
		 */
		update() {
			updateParcela(this.model).then((response) => {
				const { result: model, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.formataModelParaCrud(model)

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)
					this.$set(this.modelList, indexModel, model)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */ toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(talhao) =>
						this.modelsIdWithCheckedToDelete.includes(talhao.id) &&
						talhao.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteParcelaByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var parcelasOrganizadas = existeRegistroComDependencia
						.map((parcela) => `• Parcela: ${parcela.prla_cd_codigo} / Plantio: ${parcela.plantio}`)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaAposProcessamento')}:</b> <br/><br/> ${parcelasOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.fk_os = model.ordemServicoId
			this.model = Object.assign({}, model)

			this.titleForm = `${this.$t('edit')} ${this.$t('plot')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('plot')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		downloadCSVParcela() {
			let cabecalhoDoCsvParcela = [
				'Código',
				'Plantio',
				'Descrição',
				'Formato',
				'Inclinação',
				'Área',
				'Coordenada X',
				'Coordenada Y',
			]
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvParcela,
				...items.map((item) => [
					item.prla_cd_codigo,
					item.plantio,
					item.prla_ds_descricao,
					item.prla_tx_formato,
					item.prla_md_inclinacao,
					item.prla_md_area,
					item.prla_md_coord_x,
					item.prla_md_coord_y,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_parcela.csv', 'text/csv')
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
